






























import {
    Vue,
    Component,
    Prop,
    Watch,
} from "@/shared/vuepack";

import { EmployerPayer } from "@/shared/types";
import { useEmployerStore } from "@/admin/store/employer";
import { useNotifierStore } from "@/shared/store/notifier";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component
export default class EmployerPricing extends Vue {
  @Prop() employerId: number;

  employerStore = useEmployerStore();
  notifierStore = useNotifierStore();
  featureFlagStore = useFeatureFlagStore();
  rolePermissions = useRolePermissionsStore();
  billingSubmitDisabled = false;
  billingAmount: EmployerPayer | false = false;

  created () {
    this.fetchPricingSettings();
  }

  mounted () {
    this.billingAmount = this.billingForEmployer;
  }

  payerList = [
    { text: "Employer", value: true },
    { text: "Employee", value: false }
  ];

  @Watch("billingForEmployer", { deep: true })
  onStoreValueChange (newValue) {
    this.billingAmount = newValue;
  }

  @Watch("employerId")
  fetchPricingSettings () {
    this.billingAmount = null;
    this.billingSubmitDisabled = false;
    this.employerStore.loadEmployerBilling(this.employerId);
  }

  get billingForEmployer () {
    const storeValue = this.employerStore.billing[this.employerId];
    return storeValue ? storeValue : false;
  }

  updatePricing () {
    this.$validator.validateAll().then(isValid => {

      if (!isValid || this.billingSubmitDisabled || !this.billingAmount) {
        return;
      }

      this.billingSubmitDisabled = true;
      const employerId = this.employerId;
      const payload = {
        employerPays: this.billingAmount.employerPays,
        pricePerEmployeePerMonth: this.billingAmount.pricePerEmployeePerMonth,
        balanceFeeWaiverEnabled: this.billingAmount.balanceFeeWaiverEnabled
      };

      this.employerStore.updateEmployerBilling({ employerId, payload })
        .then(() => {
          this.notifierStore.setSuccess("Saved");
        })
        .finally(() => this.billingSubmitDisabled = false);
    });
  }
}
